import uuid from '../uuid';
import { PlayerAhoyEvent } from '../player_ahoy_event';
import { PlayerEnvironment } from '../player_environment';

export default class PlaybackBufferEvent {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._bufferId = undefined;
    this._codec = undefined;
    this.setAhoyEventGlobalProperties();
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  codec() {
    return this._codec;
  }

  bufferId() {
    if (this._bufferId === undefined) {
      return this._bufferId = uuid.v4();
    }
    return this._bufferId;
  }

  start() {
    this.sendEvent('start');
  }

  end() {
    if (this._bufferId !== undefined) {
      this.sendEvent('end');
      this.clearBufferId();
    }
  }

  sendEvent(state) {
    PlayerAhoyEvent.sendPlaybackBuffer({
      buffer_id: this.bufferId(),
      play_uuid: this.data().playUUID(),
      content_type: this.data().type(),
      content_id: this.data().videoId(),
      is_premium: this.data().isPremier(),
      state: state,
      quality: this.tech().getQuality(),
      bandwidth: this.tech().getBandwidth(),
      is_preview: this.data().preview(),
      codec: this.codec(),
      video_source_bitrate: this.tech().getVideoSourceBitrate(),
      video_source_height: this.tech().getVideoSourceHeight(),
      video_source_width: this.tech().getVideoSourceWidth(),
      player_height: this.tech().getPlayerHeight(),
      player_width: this.tech().getPlayerWidth(),
    });
  }

  clearBufferId() {
    this._bufferId = undefined;
  }

  setCodec(codec) {
    this._codec = codec;
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
